import { Directive, HostListener, Input } from '@angular/core';
import { ScrollToService } from './scrollTo.service';
import * as ɵngcc0 from '@angular/core';
var ScrollToDirective = (function () {
    function ScrollToDirective(scrollToService) {
        this.scrollToService = scrollToService;
    }
    ScrollToDirective.prototype.ngOnInit = function () {
        this.scrollDuration = (!this.scrollDuration) ? 500 : this.scrollDuration;
        this.scrollOffset = (!this.scrollOffset) ? 0 : this.scrollOffset;
    };
    ScrollToDirective.prototype.onMouseClick = function () {
        this.scrollToService.scrollTo(this.scrollTo, this.scrollDuration, this.scrollOffset);
    };
ScrollToDirective.ɵfac = function ScrollToDirective_Factory(t) { return new (t || ScrollToDirective)(ɵngcc0.ɵɵdirectiveInject(ScrollToService)); };
ScrollToDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ScrollToDirective, selectors: [["", "scrollTo", ""]], hostBindings: function ScrollToDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousedown", function ScrollToDirective_mousedown_HostBindingHandler($event) { return ctx.onMouseClick(); });
    } }, inputs: { scrollDuration: "scrollDuration", scrollOffset: "scrollOffset", scrollTo: "scrollTo" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ScrollToDirective, [{
        type: Directive,
        args: [{
                selector: '[scrollTo]'
            }]
    }], function () { return [{ type: ScrollToService }]; }, { scrollDuration: [{
            type: Input,
            args: ['scrollDuration']
        }], scrollOffset: [{
            type: Input,
            args: ['scrollOffset']
        }], onMouseClick: [{
            type: HostListener,
            args: ['mousedown']
        }], scrollTo: [{
            type: Input,
            args: ['scrollTo']
        }] }); })();
    return ScrollToDirective;
}());
export { ScrollToDirective };
/** @nocollapse */
ScrollToDirective.ctorParameters = function () { return [
    { type: ScrollToService, },
]; };
ScrollToDirective.propDecorators = {
    'scrollTo': [{ type: Input, args: ['scrollTo',] },],
    'scrollDuration': [{ type: Input, args: ['scrollDuration',] },],
    'scrollOffset': [{ type: Input, args: ['scrollOffset',] },],
    'onMouseClick': [{ type: HostListener, args: ['mousedown',] },],
};

//# sourceMappingURL=scrollTo.directive.js.map